import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import Flex from 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
var Set = styled(Flex).withConfig({
  displayName: "styled__Set",
  componentId: "sc-18btutf-0"
})(["", ";& > *{", ";", ";}&{", ";}"], function (props) {
  return props.isVertical ? css(["flex-direction:column;", ";"], function (props) {
    return !props.isFilled && css(["align-items:flex-start;"]);
  }) : css(["flex-wrap:wrap;align-items:center;justify-content:flex-start;margin-left:-", "rem;margin-top:-", "rem;"], function (props) {
    return space(props.spacing)(props);
  }, function (props) {
    return space(props.spacing)(props);
  });
}, function (props) {
  return props.isVertical ? css(["&:not(:last-child){margin-bottom:", "rem;}"], function (props) {
    return space(props.spacing)(props);
  }) : css(["margin-left:", "rem;margin-top:", "rem;"], function (props) {
    return space(props.spacing)(props);
  }, function (props) {
    return space(props.spacing)(props);
  });
}, theme('fannypack.Set.child'), theme('fannypack.Set.base'));
export default Set;
export { Set };